import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TerminalCard from "./TerminalCard";
import { useTranslation } from "../../i18n";

function Home2() {
  const { t } = useTranslation();

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col xs={12} md={8} className="home-about-description">
            <h1 className="home-intro-heading">
              {t("home.introTitle")}{" "}
              <span className="purple"> {t("home.introHighlight")} </span>{" "}
              {t("home.introSuffix")}
            </h1>
            <p className="home-about-body">
              {t("home.introP1")}{" "}
              <b className="purple">{t("home.introRole")}</b>{" "}
              {t("home.introP1End")}
              <br />
              <br />
              {t("home.introP2")}
              <br />
              <br />
              {t("home.introP3")}{" "}
              <i>
                <b className="purple"> {t("home.introDegree")} </b>
              </i>{" "}
              {t("home.introP3End")}
              <br />
              <br />
              {t("home.introP4")}
              <i>
                <b className="purple"> {t("home.introInterests")} </b>
              </i>{" "}
              {t("home.introP4End")}
              <br />
              <br />
              {t("home.introP5")}
            </p>
          </Col>
          <Col xs={12} md={4} className="myAvtar home-terminal-col">
            <TerminalCard />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
